import {Brick, registerBrick, Service} from 'olympe';
import {USER_SERVICE_TOPICS} from '../../services/service_api/CreateUserService.brick';

/**
 * This brick gets the information of a user from the user service.
 */
export default class GetUsersInfoFromUserService extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {string} userID
     * @param {number} numberOfBackends
     * @param {function()} forwardEvent
     * @param {function(Map)} setInfo
     */
    async update($, [userID, numberOfBackends], [forwardEvent, setInfo]) {
        const results = new Map;
        let i = 0;

        while (results.size < numberOfBackends && i++ < 10) {
            const data = await Service.get('userService', {topic: USER_SERVICE_TOPICS.GET_USER_INFO, userId: userID});
            const backendId = data.backendId;
            if (!results.has(backendId)) {
                results.set(backendId, data);
            }
        }

        setInfo(results);
        forwardEvent();
    }
}

registerBrick('019cd741485af0d02769', GetUsersInfoFromUserService);
